import { styled } from "@mui/system";
import {
  BORDER_SECONDARY,
  DISPLAY_FLEX,
  FLEX_ALIGN_CENTER,
  FLEX_DIRECTION_COLUMN,
  FLEX_DIRECTION_ROW,
  FLEX_JUSTIFY_SPACE_BETWEEN,
  FONT_WEIGHT_BOLD,
  MAX_WIDTH,
  TEXT_ALIGN_LEFT,
} from "../../config/styles";

export const ProductsStyled = styled("div")(({ theme }) => ({
  "& .welcome-page-container": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_COLUMN,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
    padding: "36px 24px 24px 24px",
    marginLeft: "256px",
    backgroundColor: theme.palette.secondary.contrastText,
  },
  "& .table-footer-container": {
    width: MAX_WIDTH,
    padding: "16px 0px",
  },
}));

export const ProductAGgridStyled = styled("div")(({ theme }) => ({
  "& .ag-header": {
    backgroundColor: theme.palette.background.default,
    borderBottom: BORDER_SECONDARY,
    ...theme.typography.h4,
    fontWeight: FONT_WEIGHT_BOLD,
  },
  "& .ag-header-cell": {
    backgroundColor: theme.palette.background.default,
    borderRight: "none !important",
  },
  "& .ag-header-cell-resize": {
    display: "none !important",
  },
  "& .ag-row": {
    borderBottom: BORDER_SECONDARY,
    alignItems: FLEX_ALIGN_CENTER,
  },
  "& .ag-cell-value": {
    ...theme.typography.subtitle2,
    textAlign: TEXT_ALIGN_LEFT,
    paddingTop: "14px",
    paddingBottom: "14px",
  },
  "& .ag-column-first": {
    display: DISPLAY_FLEX,
    flexDirection: FLEX_DIRECTION_ROW,
    alignItems: FLEX_ALIGN_CENTER,
    justifyContent: FLEX_JUSTIFY_SPACE_BETWEEN,
  },
    "& .ag-cell": {
    border: "none !important",
  },
  "& .ag-pinned-left-header": {
    border: "none !important",
  },
  "& .ag-pinned-right-header": {
    border: "none !important",
  },
}));
